@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.profile.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.profile.resources/"

@delegate:ResourceContentHash(110_354_156)
internal val Res.string.appearance_dark: StringResource by lazy {
      StringResource("string:appearance_dark", "appearance_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 368, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 260, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 184, 31),
      ))
    }

@delegate:ResourceContentHash(-448_808_081)
internal val Res.string.appearance_light: StringResource by lazy {
      StringResource("string:appearance_light", "appearance_light", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 404, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 292, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216, 32),
      ))
    }

@delegate:ResourceContentHash(1_013_855_014)
internal val Res.string.appearance_system: StringResource by lazy {
      StringResource("string:appearance_system", "appearance_system", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 441, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 325, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249, 33),
      ))
    }

@delegate:ResourceContentHash(891_042_751)
internal val Res.string.lang_english: StringResource by lazy {
      StringResource("string:lang_english", "lang_english", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 483, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 363, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283, 32),
      ))
    }

@delegate:ResourceContentHash(1_735_552_202)
internal val Res.string.lang_french: StringResource by lazy {
      StringResource("string:lang_french", "lang_french", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 524, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 396, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316, 27),
      ))
    }

@delegate:ResourceContentHash(135_423_525)
internal val Res.string.lang_persian: StringResource by lazy {
      StringResource("string:lang_persian", "lang_persian", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 564, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 428, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344, 32),
      ))
    }

@delegate:ResourceContentHash(1_264_996_664)
internal val Res.string.profile_about_details: StringResource by lazy {
      StringResource("string:profile_about_details", "profile_about_details", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 601, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 457, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 377, 41),
      ))
    }

@delegate:ResourceContentHash(712_055_461)
internal val Res.string.profile_about_empty: StringResource by lazy {
      StringResource("string:profile_about_empty", "profile_about_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 647, 191),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 499, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 419, 95),
      ))
    }

@delegate:ResourceContentHash(-6_442_344)
internal val Res.string.profile_about_interests: StringResource by lazy {
      StringResource("string:profile_about_interests", "profile_about_interests", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 839, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 627, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 515, 43),
      ))
    }

@delegate:ResourceContentHash(1_234_592_299)
internal val Res.string.profile_about_title: StringResource by lazy {
      StringResource("string:profile_about_title", "profile_about_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 911, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 675, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 559, 35),
      ))
    }

@delegate:ResourceContentHash(-57_755_061)
internal val Res.string.profile_action_manage: StringResource by lazy {
      StringResource("string:profile_action_manage", "profile_action_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 955, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 715, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 595, 37),
      ))
    }

@delegate:ResourceContentHash(-1_731_035_002)
internal val Res.string.profile_action_view_all: StringResource by lazy {
      StringResource("string:profile_action_view_all", "profile_action_view_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1001, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 753, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 633, 43),
      ))
    }

@delegate:ResourceContentHash(-1_774_718_424)
internal val Res.string.profile_avatar_a11y: StringResource by lazy {
      StringResource("string:profile_avatar_a11y", "profile_avatar_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1053, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 797, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 677, 47),
      ))
    }

@delegate:ResourceContentHash(157_111_186)
internal val Res.string.profile_badge_new: StringResource by lazy {
      StringResource("string:profile_badge_new", "profile_badge_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1109, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 845, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 725, 29),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.profile_blocked_back_a11y: StringResource by lazy {
      StringResource("string:profile_blocked_back_a11y", "profile_blocked_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1147, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 883, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 755, 41),
      ))
    }

@delegate:ResourceContentHash(591_216_682)
internal val Res.string.profile_blocked_empty_desc: StringResource by lazy {
      StringResource("string:profile_blocked_empty_desc", "profile_blocked_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1197, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 925, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 797, 82),
      ))
    }

@delegate:ResourceContentHash(-987_028_861)
internal val Res.string.profile_blocked_empty_title: StringResource by lazy {
      StringResource("string:profile_blocked_empty_title", "profile_blocked_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1356, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1028, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 880, 59),
      ))
    }

@delegate:ResourceContentHash(-345_338_091)
internal val Res.string.profile_blocked_unblock: StringResource by lazy {
      StringResource("string:profile_blocked_unblock", "profile_blocked_unblock", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1444, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1100, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 940, 43),
      ))
    }

@delegate:ResourceContentHash(-12_028_172)
internal val Res.string.profile_blocked_users: StringResource by lazy {
      StringResource("string:profile_blocked_users", "profile_blocked_users", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1602, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1226, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1046, 49),
      ))
    }

@delegate:ResourceContentHash(-602_612_082)
internal val Res.string.profile_blocked_users_sub: StringResource by lazy {
      StringResource("string:profile_blocked_users_sub", "profile_blocked_users_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1504, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1148, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 984, 61),
      ))
    }

@delegate:ResourceContentHash(426_996_337)
internal val Res.string.profile_delete_account: StringResource by lazy {
      StringResource("string:profile_delete_account", "profile_delete_account", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1775, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1391, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1187, 50),
      ))
    }

@delegate:ResourceContentHash(385_842_335)
internal val Res.string.profile_delete_account_sub: StringResource by lazy {
      StringResource("string:profile_delete_account_sub", "profile_delete_account_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1668, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1284, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1096, 90),
      ))
    }

@delegate:ResourceContentHash(-42_305_560)
internal val Res.string.profile_detail_hometown: StringResource by lazy {
      StringResource("string:profile_detail_hometown", "profile_detail_hometown", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1826, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1450, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1238, 43),
      ))
    }

@delegate:ResourceContentHash(-1_987_303_783)
internal val Res.string.profile_detail_speaks: StringResource by lazy {
      StringResource("string:profile_detail_speaks", "profile_detail_speaks", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1874, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1494, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1282, 45),
      ))
    }

@delegate:ResourceContentHash(-2_117_518_137)
internal val Res.string.profile_dev_env: StringResource by lazy {
      StringResource("string:profile_dev_env", "profile_dev_env", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1932, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1540, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1328, 47),
      ))
    }

@delegate:ResourceContentHash(1_173_076_239)
internal val Res.string.profile_dev_force_crash: StringResource by lazy {
      StringResource("string:profile_dev_force_crash", "profile_dev_force_crash", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1976, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1592, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1376, 55),
      ))
    }

@delegate:ResourceContentHash(1_510_902_109)
internal val Res.string.profile_dev_menu_note: StringResource by lazy {
      StringResource("string:profile_dev_menu_note", "profile_dev_menu_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2072, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1660, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1432, 101),
      ))
    }

@delegate:ResourceContentHash(-1_393_778_516)
internal val Res.string.profile_dev_menu_title: StringResource by lazy {
      StringResource("string:profile_dev_menu_title", "profile_dev_menu_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2254, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1794, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1534, 50),
      ))
    }

@delegate:ResourceContentHash(1_401_094_582)
internal val Res.string.profile_dev_seed: StringResource by lazy {
      StringResource("string:profile_dev_seed", "profile_dev_seed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2329, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1849, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1585, 48),
      ))
    }

@delegate:ResourceContentHash(-1_921_952_826)
internal val Res.string.profile_edit: StringResource by lazy {
      StringResource("string:profile_edit", "profile_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4107, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3259, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2867, 36),
      ))
    }

@delegate:ResourceContentHash(-1_885_745_684)
internal val Res.string.profile_edit_a11y: StringResource by lazy {
      StringResource("string:profile_edit_a11y", "profile_edit_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2410, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1918, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1634, 41),
      ))
    }

@delegate:ResourceContentHash(1_234_592_299)
internal val Res.string.profile_edit_bio_label: StringResource by lazy {
      StringResource("string:profile_edit_bio_label", "profile_edit_bio_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2472, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1968, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1676, 38),
      ))
    }

@delegate:ResourceContentHash(-796_615_234)
internal val Res.string.profile_edit_bio_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_bio_placeholder", "profile_edit_bio_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2519, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2011, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1715, 72),
      ))
    }

@delegate:ResourceContentHash(-1_089_136_259)
internal val Res.string.profile_edit_city_label: StringResource by lazy {
      StringResource("string:profile_edit_city_label", "profile_edit_city_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2620, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2092, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1788, 55),
      ))
    }

@delegate:ResourceContentHash(-1_738_527_836)
internal val Res.string.profile_edit_city_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_city_placeholder", "profile_edit_city_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2684, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2156, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1844, 85),
      ))
    }

@delegate:ResourceContentHash(-556_489_006)
internal val Res.string.profile_edit_hometown_label: StringResource by lazy {
      StringResource("string:profile_edit_hometown_label", "profile_edit_hometown_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2794, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2242, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1930, 47),
      ))
    }

@delegate:ResourceContentHash(-1_589_312_784)
internal val Res.string.profile_edit_hometown_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_hometown_placeholder", "profile_edit_hometown_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2858, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2302, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1978, 73),
      ))
    }

@delegate:ResourceContentHash(-1_740_359_882)
internal val Res.string.profile_edit_interests_add_a11y: StringResource by lazy {
      StringResource("string:profile_edit_interests_add_a11y", "profile_edit_interests_add_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2952, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2380, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2052, 55),
      ))
    }

@delegate:ResourceContentHash(1_530_800_946)
internal val Res.string.profile_edit_interests_label: StringResource by lazy {
      StringResource("string:profile_edit_interests_label", "profile_edit_interests_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3040, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2448, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2108, 88),
      ))
    }

@delegate:ResourceContentHash(1_488_782_962)
internal val Res.string.profile_edit_interests_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_interests_placeholder", "profile_edit_interests_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3209, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2549, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2197, 66),
      ))
    }

@delegate:ResourceContentHash(-1_057_648_185)
internal val Res.string.profile_edit_languages_label: StringResource by lazy {
      StringResource("string:profile_edit_languages_label", "profile_edit_languages_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3304, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2624, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2264, 64),
      ))
    }

@delegate:ResourceContentHash(1_689_236_891)
internal val Res.string.profile_edit_name_label: StringResource by lazy {
      StringResource("string:profile_edit_name_label", "profile_edit_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3409, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2685, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2329, 47),
      ))
    }

@delegate:ResourceContentHash(860_217_237)
internal val Res.string.profile_edit_name_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_name_placeholder", "profile_edit_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3469, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2733, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2377, 49),
      ))
    }

@delegate:ResourceContentHash(1_388_905_633)
internal val Res.string.profile_edit_occupation_label: StringResource by lazy {
      StringResource("string:profile_edit_occupation_label", "profile_edit_occupation_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3527, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2783, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2427, 53),
      ))
    }

@delegate:ResourceContentHash(-1_184_431_983)
internal val Res.string.profile_edit_occupation_placeholder: StringResource by lazy {
      StringResource("string:profile_edit_occupation_placeholder", "profile_edit_occupation_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3585, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2841, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2481, 95),
      ))
    }

@delegate:ResourceContentHash(1_102_965_678)
internal val Res.string.profile_edit_photo: StringResource by lazy {
      StringResource("string:profile_edit_photo", "profile_edit_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3705, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2937, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2577, 42),
      ))
    }

@delegate:ResourceContentHash(-549_730_969)
internal val Res.string.profile_edit_relationship_label: StringResource by lazy {
      StringResource("string:profile_edit_relationship_label", "profile_edit_relationship_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3756, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2988, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2620, 79),
      ))
    }

@delegate:ResourceContentHash(984_147_671)
internal val Res.string.profile_edit_save: StringResource by lazy {
      StringResource("string:profile_edit_save", "profile_edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4045, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3217, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2825, 41),
      ))
    }

@delegate:ResourceContentHash(1_577_681_480)
internal val Res.string.profile_edit_save_failed: StringResource by lazy {
      StringResource("string:profile_edit_save_failed", "profile_edit_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3848, 196),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3072, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2700, 124),
      ))
    }

@delegate:ResourceContentHash(-805_961_022)
internal val Res.string.profile_guest_hint: StringResource by lazy {
      StringResource("string:profile_guest_hint", "profile_guest_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4164, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3304, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2904, 78),
      ))
    }

@delegate:ResourceContentHash(-481_907_670)
internal val Res.string.profile_guest_name: StringResource by lazy {
      StringResource("string:profile_guest_name", "profile_guest_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4299, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3407, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2983, 34),
      ))
    }

@delegate:ResourceContentHash(-1_466_008_786)
internal val Res.string.profile_invite_message: StringResource by lazy {
      StringResource("string:profile_invite_message", "profile_invite_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4342, 222),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3446, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3018, 154),
      ))
    }

@delegate:ResourceContentHash(891_042_751)
internal val Res.string.profile_lang_en: StringResource by lazy {
      StringResource("string:profile_lang_en", "profile_lang_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4565, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3637, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3173, 35),
      ))
    }

@delegate:ResourceContentHash(349_649_487)
internal val Res.string.profile_lang_fa: StringResource by lazy {
      StringResource("string:profile_lang_fa", "profile_lang_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4609, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3673, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3209, 31),
      ))
    }

@delegate:ResourceContentHash(1_735_552_202)
internal val Res.string.profile_lang_fr: StringResource by lazy {
      StringResource("string:profile_lang_fr", "profile_lang_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4649, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3705, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3241, 31),
      ))
    }

@delegate:ResourceContentHash(1_643_601_078)
internal val Res.string.profile_member_since: StringResource by lazy {
      StringResource("string:profile_member_since", "profile_member_since", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4693, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3741, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3273, 52),
      ))
    }

@delegate:ResourceContentHash(-1_284_382_610)
internal val Res.string.profile_open_settings: StringResource by lazy {
      StringResource("string:profile_open_settings", "profile_open_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4844, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3884, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3404, 41),
      ))
    }

@delegate:ResourceContentHash(1_278_918_296)
internal val Res.string.profile_open_settings_sub: StringResource by lazy {
      StringResource("string:profile_open_settings_sub", "profile_open_settings_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4746, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3794, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3326, 77),
      ))
    }

@delegate:ResourceContentHash(-1_241_739_223)
internal val Res.string.profile_orders: StringResource by lazy {
      StringResource("string:profile_orders", "profile_orders", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5001, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4017, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3509, 34),
      ))
    }

@delegate:ResourceContentHash(-1_738_311_454)
internal val Res.string.profile_orders_sub: StringResource by lazy {
      StringResource("string:profile_orders_sub", "profile_orders_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4894, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3930, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3446, 62),
      ))
    }

@delegate:ResourceContentHash(-1_774_718_424)
internal val Res.string.profile_photo_a11y: StringResource by lazy {
      StringResource("string:profile_photo_a11y", "profile_photo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5056, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4060, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3544, 46),
      ))
    }

@delegate:ResourceContentHash(1_512_422_595)
internal val Res.string.profile_photo_add: StringResource by lazy {
      StringResource("string:profile_photo_add", "profile_photo_add", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5111, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4107, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3591, 41),
      ))
    }

@delegate:ResourceContentHash(1_840_294_903)
internal val Res.string.profile_photo_remove: StringResource by lazy {
      StringResource("string:profile_photo_remove", "profile_photo_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5165, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4157, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3633, 44),
      ))
    }

@delegate:ResourceContentHash(-2_086_522_571)
internal val Res.string.profile_photo_upload_failed: StringResource by lazy {
      StringResource("string:profile_photo_upload_failed", "profile_photo_upload_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5214, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4210, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3678, 99),
      ))
    }

@delegate:ResourceContentHash(923_613_815)
internal val Res.string.profile_photos_title: StringResource by lazy {
      StringResource("string:profile_photos_title", "profile_photos_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5366, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4330, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3778, 36),
      ))
    }

@delegate:ResourceContentHash(-935_977_310)
internal val Res.string.profile_pro_active: StringResource by lazy {
      StringResource("string:profile_pro_active", "profile_pro_active", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5415, 178),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4367, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3815, 122),
      ))
    }

@delegate:ResourceContentHash(1_930_857_992)
internal val Res.string.profile_pro_annual: StringResource by lazy {
      StringResource("string:profile_pro_annual", "profile_pro_annual", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5594, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4482, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3938, 34),
      ))
    }

@delegate:ResourceContentHash(-52_600_033)
internal val Res.string.profile_pro_badge: StringResource by lazy {
      StringResource("string:profile_pro_badge", "profile_pro_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5637, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4517, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3973, 29),
      ))
    }

@delegate:ResourceContentHash(1_001_332_701)
internal val Res.string.profile_pro_blurb: StringResource by lazy {
      StringResource("string:profile_pro_blurb", "profile_pro_blurb", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5671, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4547, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4003, 121),
      ))
    }

@delegate:ResourceContentHash(-1_524_846_240)
internal val Res.string.profile_pro_failed: StringResource by lazy {
      StringResource("string:profile_pro_failed", "profile_pro_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5849, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4681, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4125, 82),
      ))
    }

@delegate:ResourceContentHash(869_951_714)
internal val Res.string.profile_pro_manage: StringResource by lazy {
      StringResource("string:profile_pro_manage", "profile_pro_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6008, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4780, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4208, 54),
      ))
    }

@delegate:ResourceContentHash(2_062_075_314)
internal val Res.string.profile_pro_monthly: StringResource by lazy {
      StringResource("string:profile_pro_monthly", "profile_pro_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6071, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4835, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4263, 39),
      ))
    }

@delegate:ResourceContentHash(1_438_334_361)
internal val Res.string.profile_pro_plan_row: StringResource by lazy {
      StringResource("string:profile_pro_plan_row", "profile_pro_plan_row", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6115, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4875, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4303, 44),
      ))
    }

@delegate:ResourceContentHash(-607_001_348)
internal val Res.string.profile_pro_title: StringResource by lazy {
      StringResource("string:profile_pro_title", "profile_pro_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6160, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4920, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4348, 41),
      ))
    }

@delegate:ResourceContentHash(-463_727_049)
internal val Res.string.profile_relationship_in_relationship: StringResource by lazy {
      StringResource("string:profile_relationship_in_relationship", "profile_relationship_in_relationship", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6206, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4962, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4390, 68),
      ))
    }

@delegate:ResourceContentHash(-1_363_140_489)
internal val Res.string.profile_relationship_married: StringResource by lazy {
      StringResource("string:profile_relationship_married", "profile_relationship_married", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6271, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5019, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4459, 48),
      ))
    }

@delegate:ResourceContentHash(2_144_130_699)
internal val Res.string.profile_relationship_single: StringResource by lazy {
      StringResource("string:profile_relationship_single", "profile_relationship_single", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6324, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5068, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4508, 43),
      ))
    }

@delegate:ResourceContentHash(271_619_146)
internal val Res.string.profile_role_community: StringResource by lazy {
      StringResource("string:profile_role_community", "profile_role_community", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6372, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5120, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4552, 54),
      ))
    }

@delegate:ResourceContentHash(-1_568_045_616)
internal val Res.string.profile_saved_empty: StringResource by lazy {
      StringResource("string:profile_saved_empty", "profile_saved_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6427, 167),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5183, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4607, 103),
      ))
    }

@delegate:ResourceContentHash(1_793_734_692)
internal val Res.string.profile_saved_row: StringResource by lazy {
      StringResource("string:profile_saved_row", "profile_saved_row", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6745, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5405, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4797, 33),
      ))
    }

@delegate:ResourceContentHash(-150_994_924)
internal val Res.string.profile_saved_row_sub: StringResource by lazy {
      StringResource("string:profile_saved_row_sub", "profile_saved_row_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6595, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5311, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4711, 85),
      ))
    }

@delegate:ResourceContentHash(1_895_856_833)
internal val Res.string.profile_section_following: StringResource by lazy {
      StringResource("string:profile_section_following", "profile_section_following", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6807, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5447, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4831, 45),
      ))
    }

@delegate:ResourceContentHash(1_954_219_749)
internal val Res.string.profile_section_saved: StringResource by lazy {
      StringResource("string:profile_section_saved", "profile_section_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6877, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5497, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4877, 49),
      ))
    }

@delegate:ResourceContentHash(-946_350_458)
internal val Res.string.profile_section_settings: StringResource by lazy {
      StringResource("string:profile_section_settings", "profile_section_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6959, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5555, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4927, 64),
      ))
    }

@delegate:ResourceContentHash(1_429_672_746)
internal val Res.string.profile_section_your_stuff: StringResource by lazy {
      StringResource("string:profile_section_your_stuff", "profile_section_your_stuff", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7036, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5628, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4992, 50),
      ))
    }

@delegate:ResourceContentHash(1_475_870_026)
internal val Res.string.profile_setting_account: StringResource by lazy {
      StringResource("string:profile_setting_account", "profile_setting_account", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7223, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5783, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5131, 55),
      ))
    }

@delegate:ResourceContentHash(1_822_315_553)
internal val Res.string.profile_setting_account_sub: StringResource by lazy {
      StringResource("string:profile_setting_account_sub", "profile_setting_account_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7095, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5679, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5043, 87),
      ))
    }

@delegate:ResourceContentHash(-1_167_589_784)
internal val Res.string.profile_setting_admin: StringResource by lazy {
      StringResource("string:profile_setting_admin", "profile_setting_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7393, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5925, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5261, 37),
      ))
    }

@delegate:ResourceContentHash(983_538_168)
internal val Res.string.profile_setting_admin_sub: StringResource by lazy {
      StringResource("string:profile_setting_admin_sub", "profile_setting_admin_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7287, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5843, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5187, 73),
      ))
    }

@delegate:ResourceContentHash(881_383_225)
internal val Res.string.profile_setting_analytics: StringResource by lazy {
      StringResource("string:profile_setting_analytics", "profile_setting_analytics", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7745, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6177, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5461, 61),
      ))
    }

@delegate:ResourceContentHash(318_906_088)
internal val Res.string.profile_setting_analytics_sub: StringResource by lazy {
      StringResource("string:profile_setting_analytics_sub", "profile_setting_analytics_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7439, 305),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5975, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5299, 161),
      ))
    }

@delegate:ResourceContentHash(-1_838_825_009)
internal val Res.string.profile_setting_appearance: StringResource by lazy {
      StringResource("string:profile_setting_appearance", "profile_setting_appearance", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7859, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6263, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5523, 50),
      ))
    }

@delegate:ResourceContentHash(1_508_233_158)
internal val Res.string.profile_setting_daily_gem: StringResource by lazy {
      StringResource("string:profile_setting_daily_gem", "profile_setting_daily_gem", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8028, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6404, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5652, 57),
      ))
    }

@delegate:ResourceContentHash(1_802_518_207)
internal val Res.string.profile_setting_daily_gem_sub: StringResource by lazy {
      StringResource("string:profile_setting_daily_gem_sub", "profile_setting_daily_gem_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7906, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6310, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5574, 77),
      ))
    }

@delegate:ResourceContentHash(-1_712_191_759)
internal val Res.string.profile_setting_dashboard: StringResource by lazy {
      StringResource("string:profile_setting_dashboard", "profile_setting_dashboard", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8200, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6544, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5796, 57),
      ))
    }

@delegate:ResourceContentHash(539_122_415)
internal val Res.string.profile_setting_dashboard_sub: StringResource by lazy {
      StringResource("string:profile_setting_dashboard_sub", "profile_setting_dashboard_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8082, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6458, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5710, 85),
      ))
    }

@delegate:ResourceContentHash(1_767_907_957)
internal val Res.string.profile_setting_email_updates: StringResource by lazy {
      StringResource("string:profile_setting_email_updates", "profile_setting_email_updates", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8496, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6748, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5972, 65),
      ))
    }

@delegate:ResourceContentHash(951_311_961)
internal val Res.string.profile_setting_email_updates_sub: StringResource by lazy {
      StringResource("string:profile_setting_email_updates_sub", "profile_setting_email_updates_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8278, 217),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6598, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5854, 117),
      ))
    }

@delegate:ResourceContentHash(-6_442_344)
internal val Res.string.profile_setting_interests: StringResource by lazy {
      StringResource("string:profile_setting_interests", "profile_setting_interests", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8704, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6904, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6112, 45),
      ))
    }

@delegate:ResourceContentHash(-2_053_664_271)
internal val Res.string.profile_setting_interests_sub: StringResource by lazy {
      StringResource("string:profile_setting_interests_sub", "profile_setting_interests_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8610, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6830, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6038, 73),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("appearance_dark", Res.string.appearance_dark)
  map.put("appearance_light", Res.string.appearance_light)
  map.put("appearance_system", Res.string.appearance_system)
  map.put("lang_english", Res.string.lang_english)
  map.put("lang_french", Res.string.lang_french)
  map.put("lang_persian", Res.string.lang_persian)
  map.put("profile_about_details", Res.string.profile_about_details)
  map.put("profile_about_empty", Res.string.profile_about_empty)
  map.put("profile_about_interests", Res.string.profile_about_interests)
  map.put("profile_about_title", Res.string.profile_about_title)
  map.put("profile_action_manage", Res.string.profile_action_manage)
  map.put("profile_action_view_all", Res.string.profile_action_view_all)
  map.put("profile_avatar_a11y", Res.string.profile_avatar_a11y)
  map.put("profile_badge_new", Res.string.profile_badge_new)
  map.put("profile_blocked_back_a11y", Res.string.profile_blocked_back_a11y)
  map.put("profile_blocked_empty_desc", Res.string.profile_blocked_empty_desc)
  map.put("profile_blocked_empty_title", Res.string.profile_blocked_empty_title)
  map.put("profile_blocked_unblock", Res.string.profile_blocked_unblock)
  map.put("profile_blocked_users", Res.string.profile_blocked_users)
  map.put("profile_blocked_users_sub", Res.string.profile_blocked_users_sub)
  map.put("profile_delete_account", Res.string.profile_delete_account)
  map.put("profile_delete_account_sub", Res.string.profile_delete_account_sub)
  map.put("profile_detail_hometown", Res.string.profile_detail_hometown)
  map.put("profile_detail_speaks", Res.string.profile_detail_speaks)
  map.put("profile_dev_env", Res.string.profile_dev_env)
  map.put("profile_dev_force_crash", Res.string.profile_dev_force_crash)
  map.put("profile_dev_menu_note", Res.string.profile_dev_menu_note)
  map.put("profile_dev_menu_title", Res.string.profile_dev_menu_title)
  map.put("profile_dev_seed", Res.string.profile_dev_seed)
  map.put("profile_edit", Res.string.profile_edit)
  map.put("profile_edit_a11y", Res.string.profile_edit_a11y)
  map.put("profile_edit_bio_label", Res.string.profile_edit_bio_label)
  map.put("profile_edit_bio_placeholder", Res.string.profile_edit_bio_placeholder)
  map.put("profile_edit_city_label", Res.string.profile_edit_city_label)
  map.put("profile_edit_city_placeholder", Res.string.profile_edit_city_placeholder)
  map.put("profile_edit_hometown_label", Res.string.profile_edit_hometown_label)
  map.put("profile_edit_hometown_placeholder", Res.string.profile_edit_hometown_placeholder)
  map.put("profile_edit_interests_add_a11y", Res.string.profile_edit_interests_add_a11y)
  map.put("profile_edit_interests_label", Res.string.profile_edit_interests_label)
  map.put("profile_edit_interests_placeholder", Res.string.profile_edit_interests_placeholder)
  map.put("profile_edit_languages_label", Res.string.profile_edit_languages_label)
  map.put("profile_edit_name_label", Res.string.profile_edit_name_label)
  map.put("profile_edit_name_placeholder", Res.string.profile_edit_name_placeholder)
  map.put("profile_edit_occupation_label", Res.string.profile_edit_occupation_label)
  map.put("profile_edit_occupation_placeholder", Res.string.profile_edit_occupation_placeholder)
  map.put("profile_edit_photo", Res.string.profile_edit_photo)
  map.put("profile_edit_relationship_label", Res.string.profile_edit_relationship_label)
  map.put("profile_edit_save", Res.string.profile_edit_save)
  map.put("profile_edit_save_failed", Res.string.profile_edit_save_failed)
  map.put("profile_guest_hint", Res.string.profile_guest_hint)
  map.put("profile_guest_name", Res.string.profile_guest_name)
  map.put("profile_invite_message", Res.string.profile_invite_message)
  map.put("profile_lang_en", Res.string.profile_lang_en)
  map.put("profile_lang_fa", Res.string.profile_lang_fa)
  map.put("profile_lang_fr", Res.string.profile_lang_fr)
  map.put("profile_member_since", Res.string.profile_member_since)
  map.put("profile_open_settings", Res.string.profile_open_settings)
  map.put("profile_open_settings_sub", Res.string.profile_open_settings_sub)
  map.put("profile_orders", Res.string.profile_orders)
  map.put("profile_orders_sub", Res.string.profile_orders_sub)
  map.put("profile_photo_a11y", Res.string.profile_photo_a11y)
  map.put("profile_photo_add", Res.string.profile_photo_add)
  map.put("profile_photo_remove", Res.string.profile_photo_remove)
  map.put("profile_photo_upload_failed", Res.string.profile_photo_upload_failed)
  map.put("profile_photos_title", Res.string.profile_photos_title)
  map.put("profile_pro_active", Res.string.profile_pro_active)
  map.put("profile_pro_annual", Res.string.profile_pro_annual)
  map.put("profile_pro_badge", Res.string.profile_pro_badge)
  map.put("profile_pro_blurb", Res.string.profile_pro_blurb)
  map.put("profile_pro_failed", Res.string.profile_pro_failed)
  map.put("profile_pro_manage", Res.string.profile_pro_manage)
  map.put("profile_pro_monthly", Res.string.profile_pro_monthly)
  map.put("profile_pro_plan_row", Res.string.profile_pro_plan_row)
  map.put("profile_pro_title", Res.string.profile_pro_title)
  map.put("profile_relationship_in_relationship", Res.string.profile_relationship_in_relationship)
  map.put("profile_relationship_married", Res.string.profile_relationship_married)
  map.put("profile_relationship_single", Res.string.profile_relationship_single)
  map.put("profile_role_community", Res.string.profile_role_community)
  map.put("profile_saved_empty", Res.string.profile_saved_empty)
  map.put("profile_saved_row", Res.string.profile_saved_row)
  map.put("profile_saved_row_sub", Res.string.profile_saved_row_sub)
  map.put("profile_section_following", Res.string.profile_section_following)
  map.put("profile_section_saved", Res.string.profile_section_saved)
  map.put("profile_section_settings", Res.string.profile_section_settings)
  map.put("profile_section_your_stuff", Res.string.profile_section_your_stuff)
  map.put("profile_setting_account", Res.string.profile_setting_account)
  map.put("profile_setting_account_sub", Res.string.profile_setting_account_sub)
  map.put("profile_setting_admin", Res.string.profile_setting_admin)
  map.put("profile_setting_admin_sub", Res.string.profile_setting_admin_sub)
  map.put("profile_setting_analytics", Res.string.profile_setting_analytics)
  map.put("profile_setting_analytics_sub", Res.string.profile_setting_analytics_sub)
  map.put("profile_setting_appearance", Res.string.profile_setting_appearance)
  map.put("profile_setting_daily_gem", Res.string.profile_setting_daily_gem)
  map.put("profile_setting_daily_gem_sub", Res.string.profile_setting_daily_gem_sub)
  map.put("profile_setting_dashboard", Res.string.profile_setting_dashboard)
  map.put("profile_setting_dashboard_sub", Res.string.profile_setting_dashboard_sub)
  map.put("profile_setting_email_updates", Res.string.profile_setting_email_updates)
  map.put("profile_setting_email_updates_sub", Res.string.profile_setting_email_updates_sub)
  map.put("profile_setting_interests", Res.string.profile_setting_interests)
  map.put("profile_setting_interests_sub", Res.string.profile_setting_interests_sub)
}
